// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1wfBP","content":"ManualTimeModal_content__S-phd"};